import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import MediumModel from '../../../model/medium.model';

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss']
})
export class DocumentComponent implements OnInit, AfterViewInit {
  @Input() fields: any;
  @Input() object: MediumModel;
  @Output() onValueChange: EventEmitter<any> = new EventEmitter();
  @Output() onremove: EventEmitter<MediumModel> = new EventEmitter();

  @ViewChild("file") fileUploader;

  public filename: string;

  constructor(private dialog: MatDialog) {
  }

  ngOnInit(): void {
    if(this.object == null) {
      this.object = {
        description: '',
        license: '',
        file: null,
        filename: null,
        position: 0
      };
    } else if(this.object.filename != null) {
      let filename = this.object.filename.split('/').reverse()[0];

      let parts = filename.split('_');
      if(parts.length > 1) {
        parts.splice(0,1);
        filename = parts.join('_');
      }
      this.filename = filename;
    }
  }

  ngAfterViewInit() {
    if(this.object.filename == null && this.object.file == null) {
      this.fileUploader.nativeElement.click();
    }
  }

  showUploader() {
    this.fileUploader.nativeElement.click();
  }

  previewDocument(files) {
    if (files.length === 0)
      return;

    var mimeType = files[0].type;
    var reader = new FileReader();
    let documentPath = files;
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.object.file = {
        data: reader.result.toString(),
        name: this.fileUploader.nativeElement.value.split(/(\\|\/)/g).pop()
      };
      this.onValueChange.emit(this.object);
    };
  }

  public remove() {
    this.onremove.emit(this.object);
  }



}
